var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import isObjectEmpty from 'syf-js-utilities/helpers/isObjectEmpty';
import { ALERTS_FORM_ATTRIBUTE_CHANGE, ALERTS_FORM_CLOSE_ACCORDION, ALERTS_FORM_DELIVERY_CHANGE, ALERTS_FORM_FORCE_CLOSE_ACCORDION, ALERTS_FORM_INITIALIZE, ALERTS_FORM_OPEN_ACCORDION, ALERTS_FORM_PREFERENCE_UPDATE_ERROR, ALERTS_FORM_RESET_DATA, ALERTS_FORM_SET_ERROR, ALERTS_FORM_SET_IS_LOADING, ALERTS_FORM_SET_SHOULD_SHOW_TERMS_CONDITIONS } from '../actionTypes';
// eslint-disable-next-line import/no-cycle
import { ACCORDION_TRANSITION_DURATION, APPROVED_TRANSACTIONS, AlertIDType, SYF_PAY_LATER } from '../../const/alertsConfig';
import SyfStorage from '../../helpers/SyfStorage';
import { updatePreference } from '../../services/alertService';
// eslint-disable-next-line import/no-cycle
import { setAlertsDataForTermsConentBanner, setAlertsDataHasAcknowledgeTermsCondition, updateAlertDataReducer } from '../alertsData/actions';
import { getCategoryId } from '../alertsData/actionsHelpers';
import { formatAttributeValueForForm, formatAttributesForApi, formatAttributesForForm, getAttributeError, getFormIsDirty, getResetAttributes, getResetDelivery, isAttributeValueValid, turnOffAllAlertDataAttributes, turnOffAllAlertDataDeliveries, turnOffAllAttributes, turnOffAllDeliveries, validateFormData } from './actionsHelpers';
export var setFormErrors = function (id, dataErrors) {
    return {
        type: ALERTS_FORM_SET_ERROR,
        payload: {
            id: id,
            dataErrors: dataErrors
        }
    };
};
export var setAlertsFormIsLoading = function (id, isLoading) {
    return {
        type: ALERTS_FORM_SET_IS_LOADING,
        payload: {
            id: id,
            isLoading: isLoading
        }
    };
};
export var initializeAlertsForm = function (id, delivery, attributes) {
    return {
        type: ALERTS_FORM_INITIALIZE,
        payload: {
            id: id,
            delivery: __assign({}, delivery),
            attributes: attributes ? formatAttributesForForm(attributes) : null
        }
    };
};
export var forceCloseAlertsFormAccordion = function (id) {
    return {
        type: ALERTS_FORM_FORCE_CLOSE_ACCORDION,
        payload: { id: id }
    };
};
export var closeAlertsFormAccordion = function (id) {
    return {
        type: ALERTS_FORM_CLOSE_ACCORDION,
        payload: { id: id }
    };
};
export var resetAlertsFormData = function (id, preference) {
    return {
        type: ALERTS_FORM_RESET_DATA,
        payload: {
            id: id,
            delivery: preference.delivery,
            attributes: preference.attributes
                ? formatAttributesForForm(preference.attributes)
                : null
        }
    };
};
export var setShowTermsAndConditions = function (id, showTermsAndConditions) {
    return {
        type: ALERTS_FORM_SET_SHOULD_SHOW_TERMS_CONDITIONS,
        payload: {
            id: id,
            showTermsAndConditions: showTermsAndConditions
        }
    };
};
// We delay the hide terms and conditons until after the accordion is close
var hideTermsAndConditonsWithDelay = function (id, dispatch) {
    setTimeout(function () {
        dispatch(setShowTermsAndConditions(id, false));
    }, ACCORDION_TRANSITION_DURATION * 1000);
};
export var closeAccordionAndResetData = function (id) {
    return function (dispatch, getState) {
        var currentAlertData = getState().alertsData.byId[id];
        var resetAttributes = getResetAttributes(currentAlertData);
        var resetDelivery = getResetDelivery(currentAlertData);
        // purchase exceeds case in approved transactions
        var resetAttributesForPE;
        var resetDeliveryForPE;
        var isApprovedTransactionAlert = id === AlertIDType.APPROVED_TRANSACTIONS;
        if (isApprovedTransactionAlert) {
            var currentAlertDataForAT = getState().alertsData.byId.PURCHASE_EXCEEDS;
            resetAttributesForPE = getResetAttributes(currentAlertDataForAT);
            resetDeliveryForPE = getResetDelivery(currentAlertDataForAT);
        }
        dispatch(closeAlertsFormAccordion(id));
        dispatch(resetAlertsFormData(id, {
            id: id,
            attributes: resetAttributes,
            delivery: resetDelivery
        }));
        if (isApprovedTransactionAlert) {
            dispatch(resetAlertsFormData(AlertIDType.PURCHASE_EXCEEDS, {
                id: AlertIDType.PURCHASE_EXCEEDS,
                attributes: resetAttributesForPE,
                delivery: resetDeliveryForPE
            }));
        }
        hideTermsAndConditonsWithDelay(id, dispatch);
    };
};
export var openAlertsFormAccordion = function (id) {
    return {
        type: ALERTS_FORM_OPEN_ACCORDION,
        payload: { id: id }
    };
};
export var setUpdatePreferenceApiError = function (id, apiError) {
    return {
        type: ALERTS_FORM_PREFERENCE_UPDATE_ERROR,
        payload: {
            id: id,
            apiError: apiError
        }
    };
};
export var onAttributeValueChange = function (id, attributeKey, value) {
    return function (dispatch, getState) {
        var _a;
        var currentAlertData = getState().alertsData.byId[id];
        var alertFormData = getState().alertsForm[id];
        var currentAttributes = alertFormData.attributes;
        // clear any errors for this attribute on value change
        var updatedErrors = __spreadArray([], alertFormData.dataErrors, true).filter(function (error) { return error.key !== attributeKey; });
        var updatedAttributes = __assign(__assign({}, currentAttributes), (_a = {}, _a[attributeKey] = { value: value }, _a));
        var formIsDirty = getFormIsDirty(updatedAttributes, alertFormData.delivery, currentAlertData);
        if (id === AlertIDType.APPROVED_TRANSACTIONS) {
            // update attribute values for dependent alerts
            var purchaseExceedsThresholdAmountKey_1 = 'purchaseExceedsThresholdAmount';
            var purchaseExceedsThresholdAmountValue = formatAttributeValueForForm(getState().alertsData.byId.PURCHASE_EXCEEDS.attributes.find(function (attr) { return attr.key === purchaseExceedsThresholdAmountKey_1; }).value, purchaseExceedsThresholdAmountKey_1);
            var dataErrors = __spreadArray([], alertFormData.dataErrors, true).filter(function (error) { return error.key !== attributeKey; });
            dispatch({
                type: ALERTS_FORM_ATTRIBUTE_CHANGE,
                payload: {
                    id: AlertIDType.PURCHASE_EXCEEDS,
                    attributes: {
                        purchaseExceedsThresholdAmount: {
                            value: purchaseExceedsThresholdAmountValue
                        }
                    },
                    isDirty: false,
                    dataErrors: dataErrors
                }
            });
            // update deliveries for dependent alerts
            var updatedDeliveryMethods_1 = alertFormData.delivery;
            APPROVED_TRANSACTIONS.forEach(function (alertId) {
                var delivery;
                var isDirty;
                if (alertId !== value) {
                    delivery = turnOffAllDeliveries(updatedDeliveryMethods_1);
                    isDirty = false;
                }
                else {
                    delivery = updatedDeliveryMethods_1;
                    isDirty = formIsDirty;
                }
                dispatch({
                    type: ALERTS_FORM_DELIVERY_CHANGE,
                    payload: {
                        id: alertId,
                        delivery: delivery,
                        isDirty: isDirty,
                        dataErrors: updatedErrors
                    }
                });
            });
        }
        dispatch({
            type: ALERTS_FORM_ATTRIBUTE_CHANGE,
            payload: {
                id: id,
                attributes: updatedAttributes,
                isDirty: formIsDirty,
                dataErrors: updatedErrors
            }
        });
    };
};
export var onDeliveryValueChange = function (id, deliveryKey, enrolled) {
    return function (dispatch, getState) {
        var _a;
        var currentAlertData = getState().alertsData.byId[id];
        var alertFormData = getState().alertsForm[id];
        var _b = getState().profileData, phone = _b.phone, profileApiError = _b.profileApiError;
        // clear any errors for delivery on value change
        var updatedErrors = __spreadArray([], alertFormData.dataErrors, true).filter(function (error) { return error.key !== 'delivery'; });
        // clear any errors for phoneWarning on text value change
        updatedErrors =
            deliveryKey.valueOf() === 'text'
                ? updatedErrors.filter(function (error) { return error.key !== 'phoneWarning'; })
                : updatedErrors;
        var shouldAddPhoneWarning = deliveryKey.valueOf() === 'text' && enrolled && !phone && !profileApiError;
        if (shouldAddPhoneWarning) {
            updatedErrors.push({
                key: 'phoneWarning',
                value: 'phoneWarning'
            });
        }
        var updatedDeliveryMethods = __assign(__assign({}, alertFormData.delivery), (_a = {}, _a[deliveryKey] = { enrolled: enrolled }, _a));
        var formIsDirty = getFormIsDirty(alertFormData.attributes, updatedDeliveryMethods, currentAlertData);
        // update dependent deliveries FOR APPROVED_TRANSACTIONS
        if (id === AlertIDType.APPROVED_TRANSACTIONS) {
            var approvedTransactionType = alertFormData.attributes.approvedTransactionType.value;
            if (approvedTransactionType) {
                dispatch({
                    type: ALERTS_FORM_DELIVERY_CHANGE,
                    payload: {
                        id: alertFormData.attributes.approvedTransactionType.value,
                        delivery: updatedDeliveryMethods,
                        isDirty: formIsDirty,
                        dataErrors: updatedErrors
                    }
                });
            }
        }
        if (id === AlertIDType.SYF_PAY_LATER) {
            SYF_PAY_LATER.forEach(function (alertID) {
                dispatch({
                    type: ALERTS_FORM_DELIVERY_CHANGE,
                    payload: {
                        id: alertID,
                        delivery: updatedDeliveryMethods,
                        isDirty: formIsDirty,
                        dataErrors: updatedErrors
                    }
                });
            });
        }
        dispatch({
            type: ALERTS_FORM_DELIVERY_CHANGE,
            payload: {
                id: id,
                delivery: updatedDeliveryMethods,
                isDirty: formIsDirty,
                dataErrors: updatedErrors
            }
        });
    };
};
export var validateAndFormatAttributeValue = function (id, attributeKey) {
    return function (dispatch, getState) {
        var _a;
        var alertFormData = getState().alertsForm[id];
        var currentAttributes = alertFormData.attributes;
        var currentAttributeValue = currentAttributes[attributeKey].value;
        // clear any errors for this attribute on value change
        var updatedErrors = __spreadArray([], alertFormData.dataErrors, true).filter(function (error) { return error.key !== attributeKey; });
        var isValid = isAttributeValueValid(currentAttributeValue, attributeKey);
        if (!isValid) {
            updatedErrors.push(getAttributeError(attributeKey));
        }
        var formattedValue = formatAttributeValueForForm(currentAttributeValue, attributeKey);
        dispatch({
            type: ALERTS_FORM_ATTRIBUTE_CHANGE,
            payload: {
                id: id,
                attributes: __assign(__assign({}, currentAttributes), (_a = {}, _a[attributeKey] = {
                    value: isValid ? formattedValue : currentAttributeValue
                }, _a)),
                isDirty: alertFormData.isDirty,
                dataErrors: updatedErrors
            }
        });
    };
};
var getUpdatePrefForApprovedTransactions = function (alertsForm, isTurnOffPreference) {
    var updatedPreferences = [];
    APPROVED_TRANSACTIONS.forEach(function (alertId) {
        var _a, _b;
        if (alertsForm[alertId]) {
            var delivery = isTurnOffPreference
                ? turnOffAllDeliveries(alertsForm[alertId].delivery)
                : alertsForm[alertId].delivery;
            var attributes = isTurnOffPreference
                ? turnOffAllAttributes(alertsForm[alertId].attributes)
                : alertsForm[alertId].attributes;
            // FORMAT ATTRIBUTES FOR API
            if (alertId === AlertIDType.PURCHASE_EXCEEDS) {
                attributes = formatAttributesForApi(attributes);
            }
            /*
             * removes empty attribute object and
             * handling unenroll purchase_exceeds threshold attribute value in PUT call
             */
            if (isObjectEmpty(attributes) ||
                (alertId === AlertIDType.PURCHASE_EXCEEDS &&
                    ((_b = (_a = alertsForm.APPROVED_TRANSACTIONS.attributes) === null || _a === void 0 ? void 0 : _a.approvedTransactionType) === null || _b === void 0 ? void 0 : _b.value) === AlertIDType.TRANSACTION_AUTHORIZATION)) {
                attributes = undefined;
            }
            updatedPreferences.push({
                id: alertId,
                delivery: delivery,
                attributes: attributes
            });
        }
    });
    return updatedPreferences;
};
var getUpdatePrefForSYFPayLater = function (alertsForm) {
    var updatedPreferences = [];
    SYF_PAY_LATER.forEach(function (alertId) {
        if (alertsForm[alertId]) {
            var delivery = alertsForm[alertId].delivery;
            updatedPreferences.push({
                id: alertId,
                delivery: delivery
            });
        }
    });
    return updatedPreferences;
};
var handleAcceptedStatus = function (dispatch, isConsentChanged) {
    if (isConsentChanged) {
        dispatch(setAlertsDataHasAcknowledgeTermsCondition(false));
    }
};
var callUpdateAlertsPreference = function (currentAlertUpdatedPreferences, isTurnOffPreference) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, token, syfIdentifier, _b, alertType, apiHost, correlationId, alertID, hasAcknowledgeTermsConditions, alertFormData, isTermsConditionsVisible, isConsentChanged, statusCode, purchaseExceedsAttributes, purchaseExceedDelivery, updatedPreferences, updatePreferencesForPE, updatePreferenceRequest, err_1;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = getState().authorizationReducer, token = _a.token, syfIdentifier = _a.syfIdentifier;
                    _b = getState().appConfig, alertType = _b.alertType, apiHost = _b.apiHost;
                    correlationId = SyfStorage.getCorrelationId();
                    alertID = currentAlertUpdatedPreferences.id;
                    hasAcknowledgeTermsConditions = getState().alertsData.hasAcknowledgeTermsConditions;
                    alertFormData = getState().alertsForm[alertID];
                    isTermsConditionsVisible = alertFormData.showTermsAndConditions;
                    isConsentChanged = isTermsConditionsVisible && hasAcknowledgeTermsConditions;
                    dispatch(setAlertsFormIsLoading(alertID, true));
                    // special alert approved_transactions handling
                    if (alertID === AlertIDType.APPROVED_TRANSACTIONS) {
                        updatedPreferences = getUpdatePrefForApprovedTransactions(getState().alertsForm, isTurnOffPreference);
                        updatePreferencesForPE = updatedPreferences.filter(function (alert) { return alert.id === AlertIDType.PURCHASE_EXCEEDS; });
                        purchaseExceedsAttributes = updatePreferencesForPE[0].attributes || {
                            purchaseExceedsThresholdAmount: { value: '' }
                        };
                        purchaseExceedDelivery = updatePreferencesForPE[0].delivery;
                    }
                    else if (alertID === AlertIDType.SYF_PAY_LATER) {
                        updatedPreferences = getUpdatePrefForSYFPayLater(getState().alertsForm);
                    }
                    else {
                        updatedPreferences = [currentAlertUpdatedPreferences];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updatePreference({
                            token: token,
                            syfIdentifier: syfIdentifier,
                            updatedPreferences: updatedPreferences,
                            isConsentChanged: isConsentChanged,
                            tokenId: correlationId,
                            isTurnOffPreference: isTurnOffPreference,
                            apiHost: apiHost
                        })];
                case 2:
                    updatePreferenceRequest = _d.sent();
                    statusCode = updatePreferenceRequest.status;
                    if (statusCode !== 202) {
                        handleAcceptedStatus(dispatch, isConsentChanged);
                        throw new Error("".concat(statusCode));
                    }
                    updateAlertDataReducer(alertID, currentAlertUpdatedPreferences.attributes, currentAlertUpdatedPreferences.delivery)(dispatch, getState);
                    if (alertID === AlertIDType.APPROVED_TRANSACTIONS) {
                        updateAlertDataReducer(AlertIDType.PURCHASE_EXCEEDS, purchaseExceedsAttributes, purchaseExceedDelivery)(dispatch, getState);
                    }
                    // if approved_transactions dispatch all dependent alerts
                    if (alertType === AlertIDType.ALL) {
                        dispatch(forceCloseAlertsFormAccordion(alertID));
                        dispatch(resetAlertsFormData(alertID, {
                            id: alertID,
                            attributes: currentAlertUpdatedPreferences.attributes,
                            delivery: currentAlertUpdatedPreferences.delivery
                        }));
                        if (alertID === AlertIDType.APPROVED_TRANSACTIONS) {
                            dispatch(resetAlertsFormData(AlertIDType.PURCHASE_EXCEEDS, {
                                id: AlertIDType.PURCHASE_EXCEEDS,
                                attributes: purchaseExceedsAttributes,
                                delivery: purchaseExceedDelivery
                            }));
                        }
                    }
                    dispatch(setAlertsFormIsLoading(alertID, false));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _d.sent();
                    if (statusCode !== 202) {
                        handleAcceptedStatus(dispatch, isConsentChanged);
                        dispatch(setUpdatePreferenceApiError(alertID, err_1.message));
                        sessionStorage.setItem('apiError', JSON.stringify({
                            err: err_1.message,
                            alertId: alertID === null || alertID === void 0 ? void 0 : alertID.toLowerCase().replace(/_/g, ' '),
                            alertCategory: (_c = getCategoryId(alertID)) === null || _c === void 0 ? void 0 : _c.toLowerCase()
                        }));
                    }
                    dispatch(setAlertsFormIsLoading(alertID, false));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var onTurnOffPreference = function (id) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var currentAlertData, attributes, allDeliveryMethods, turnOffAttributes, turnedOffDelivery, turnOffPreferenceData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentAlertData = getState().alertsData.byId[id];
                    attributes = currentAlertData.attributes, allDeliveryMethods = currentAlertData.allDeliveryMethods;
                    if (attributes.length > 0) {
                        turnOffAttributes = turnOffAllAlertDataAttributes(attributes);
                    }
                    turnedOffDelivery = turnOffAllAlertDataDeliveries(allDeliveryMethods);
                    turnOffPreferenceData = {
                        id: id,
                        delivery: turnedOffDelivery,
                        attributes: turnOffAttributes
                    };
                    return [4 /*yield*/, callUpdateAlertsPreference(turnOffPreferenceData, true)(dispatch, getState)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
export var onUpdatePreference = function (id) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var currentAlertData, isAlertOn, allDeliveryMethods, alertFormData, allDeliveryMethodsOff, allAttributesEmpty, hasPurchaseExceedsValue, purchaseExceedsThresholdAmount, errors, hasAcknowledgeTermsConditions, hasSelectedText, formattedAttributesForApi, updatePreferenceData;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    currentAlertData = getState().alertsData.byId[id];
                    isAlertOn = currentAlertData.isAlertOn, allDeliveryMethods = currentAlertData.allDeliveryMethods;
                    alertFormData = getState().alertsForm[id];
                    // Handle special case approved transactions - purchase exceeds already on alert
                    if (id !== AlertIDType.APPROVED_TRANSACTIONS &&
                        !alertFormData.isDirty &&
                        isAlertOn) {
                        return [2 /*return*/];
                    }
                    allDeliveryMethodsOff = allDeliveryMethods.every(function (delMethod) { return !alertFormData.delivery[delMethod.key].enrolled; });
                    allAttributesEmpty = Object.values(alertFormData.attributes || {}).every(function (attribute) { return !attribute.value; });
                    if (!(isAlertOn && allDeliveryMethodsOff && allAttributesEmpty)) return [3 /*break*/, 2];
                    return [4 /*yield*/, onTurnOffPreference(id)(dispatch, getState)];
                case 1:
                    _d.sent();
                    return [2 /*return*/];
                case 2:
                    hasPurchaseExceedsValue = ((_b = (_a = alertFormData === null || alertFormData === void 0 ? void 0 : alertFormData.attributes) === null || _a === void 0 ? void 0 : _a.approvedTransactionType) === null || _b === void 0 ? void 0 : _b.value) ===
                        AlertIDType.PURCHASE_EXCEEDS;
                    purchaseExceedsThresholdAmount = (_c = getState().alertsData.byId.PURCHASE_EXCEEDS) === null || _c === void 0 ? void 0 : _c.attributes[0].key;
                    if (id === AlertIDType.APPROVED_TRANSACTIONS && hasPurchaseExceedsValue) {
                        validateAndFormatAttributeValue(AlertIDType.PURCHASE_EXCEEDS, purchaseExceedsThresholdAmount)(dispatch, getState);
                    }
                    errors = validateFormData(alertFormData, currentAlertData, getState().alertsForm);
                    if (errors.length > 0) {
                        dispatch(setFormErrors(id, errors));
                        return [2 /*return*/];
                    }
                    hasAcknowledgeTermsConditions = getState().alertsData.hasAcknowledgeTermsConditions;
                    hasSelectedText = alertFormData.delivery.text.enrolled;
                    if (hasSelectedText && !hasAcknowledgeTermsConditions) {
                        dispatch(setShowTermsAndConditions(id, true));
                        return [2 /*return*/];
                    }
                    formattedAttributesForApi = formatAttributesForApi(alertFormData.attributes);
                    updatePreferenceData = {
                        id: id,
                        delivery: __assign({}, alertFormData.delivery),
                        attributes: __assign({}, formattedAttributesForApi)
                    };
                    if (isObjectEmpty(updatePreferenceData.attributes)) {
                        delete updatePreferenceData.attributes;
                    }
                    return [4 /*yield*/, callUpdateAlertsPreference(updatePreferenceData)(dispatch, getState)];
                case 3:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
export var onTermsAndConditionsAccepted = function (id) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setAlertsDataHasAcknowledgeTermsCondition(true));
                    dispatch(setAlertsDataForTermsConentBanner(false));
                    return [4 /*yield*/, onUpdatePreference(id)(dispatch, getState)];
                case 1:
                    _a.sent();
                    hideTermsAndConditonsWithDelay(id, dispatch);
                    return [2 /*return*/];
            }
        });
    }); };
};
// TODO: find a better approach this exports were added since cy.spy does not support ES modules
export var alertsFormActions = {
    onAttributeValueChange: onAttributeValueChange,
    closeAccordionAndResetData: closeAccordionAndResetData,
    openAlertsFormAccordion: openAlertsFormAccordion,
    onTurnOffPreference: onTurnOffPreference
};
